var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("Lizenz in Riskop einspielen")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "\n    Speichern Sie die Datei lokal bei sich auf dem PC (nicht auf dem Server)\n"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n    Öffnen Sie folgende URL:\n    "),
          _c("code", [
            _vm._v("http(s)://...ihr.riskop.../riskop/admin/Start.do"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _c("img", {
              staticClass: "help-image",
              attrs: {
                src: require("../../../../webapp/images/license-riskop-1.png"),
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n    Wählen Sie die in Schritt 1 gespeicherte Datei.\n    "),
          _c("div", { staticClass: "text-center" }, [
            _c("img", {
              staticClass: "help-image",
              attrs: {
                src: require("../../../../webapp/images/license-riskop-2.png"),
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n    Bestätigen Sie mit "),
          _c("code", [_vm._v("OK")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }